/**
 * MotoristaResponsavel
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {ResponseSerialize} from 'simpli-web-sdk'
import {Motorista} from '@/model/resource/Motorista'
import {Responsavel} from '@/model/resource/Responsavel'
import {MotoristaResponsavelCollection} from '@/model/collection/MotoristaResponsavelCollection'

/* TODO: review generated class */
export class MotoristaResponsavel extends Resource {
  @ResponseSerialize(Motorista)
  motorista: Motorista | null = null

  @ResponseSerialize(Responsavel)
  responsavel: Responsavel | null = null

  /**
   * Se o responsavel que cadastrar o motorista, então deixar o apelido igual do nomeFantasia
   */
  apelido: string | null = null

  get $id() {
    /* TODO: define the ID */
    return 0
  }
  set $id(val) {
    /* TODO: define the ID */
  }

  get idMotoristaFk() {
    if (!this.motorista) return 0
    return this.motorista.$id
  }
  set idMotoristaFk(val) {
    if (!this.motorista) this.motorista = new Motorista()
    this.motorista.$id = val
  }

  get idResponsavelFk() {
    if (!this.responsavel) return 0
    return this.responsavel.$id
  }
  set idResponsavelFk(val) {
    if (!this.responsavel) this.responsavel = new Responsavel()
    this.responsavel.$id = val
  }

  /**
   * Gets a instance of a given ID of MotoristaResponsavel
   */
  async getMotoristaResponsavel(id1: number, id2: number) {
    return await Request.get(`/admin/motorista-responsavel/${id1}/${id2}`)
      .name('getMotoristaResponsavel')
      .as(this)
      .getData()
  }

  /**
   * Lists the instances of MotoristaResponsavel
   */
  static async listMotoristaResponsavel(params: any) {
    return await Request.get(`/admin/motorista-responsavel`, {params})
      .name('listMotoristaResponsavel')
      .as(MotoristaResponsavelCollection)
      .getData()
  }

  /**
   * Persists a new instance of MotoristaResponsavel. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistMotoristaResponsavel() {
    return await Request.post(`/admin/motorista-responsavel`, this)
      .name('persistMotoristaResponsavel')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of MotoristaResponsavel to use it in a CSV file
   */
  static async listCsvMotoristaResponsavel(params: any) {
    return await Request.get(`/admin/motorista-responsavel/csv`, {params})
      .name('listCsvMotoristaResponsavel')
      .as(MotoristaResponsavelCollection)
      .getData()
  }
}
